<template>
    <div class="help-center-content">
        <h4>录制要求</h4>
        <p class="title">1.  录制专辑有哪些要求？</p>
        <p class="content">① 专辑封面要求清晰美观，建议图片尺寸不小于640×640像素；<br>
            ② 专辑标题为书名，不可随意更改；<br>
            ③ 专辑简介需认真填写，对作品内容进行简单介绍；<br>
            ④ 专辑内不要有和本作品无关的内容，福利节目、闲聊节目、请假等请另设专辑上传；<br>
            ⑤ 专辑更新频率至少每天1集；<br>
            ⑥ 专辑演绎方式至少为单人/双人/多人；
        </p>
        <p class="title">2.  对于录制的单条声音，有哪些要求呢？</p>
        <p class="content">① 声音标题格式为“书名+序号（+章节名）”，如:“雪中悍刀行01”、“三国演义01宴桃园豪杰三结义”；<br>
            ② 声音正序排列，即第一集排列在专辑最上面；<br>
            ③ 每条声音需在开始处增加固定片头：欢迎您收听由喜马拉雅FM出品的《XX》，作者XX，演播XX，由XX授权，第2集/回/章；<br>
            ④ 每条声音需在中间处增加固定口播：您正在收听的是由喜马拉雅FM出品的《XX》；<br>
            ⑤ 每条声音需在结束处增加固定片尾：听众朋友，本集播讲完毕，感谢您的收听；<br>
            ⑥ 专辑中的第一条声音需使用长片头，时间3分钟左右，主要用于介绍作品内容，请在理解作品后提炼精彩点，力求吸引听众继续收听；<br>
            ⑦ 专辑中的最后一条声音需追加一句完结说明，如：亲爱的听众朋友，本书已全部播讲完毕，感谢您的收听，声音标题需加上“完”。如:“雪中悍刀行280（完）”；<br>
            ⑧ 不得在作品中进行无意义的文本修改；对涉政、涉黄、脏话的内容可自行屏蔽；对明显错误内容可自行甄别后修改；允许口语化、增加合理改编；<br>
            ⑨ 每条声音时长严格控制在18-22分钟（包含片头、片中，片尾所占据的时间），最后一集时长可延长至18-40分钟；<br>
            ⑩ 作品内容要求使用标准普通话播讲，语速中等，播讲过程中感情充沛、语言生动，如有口误或错句需要剪辑掉。作品中不能出现大段空白或大段无内容垫乐，不能有故意延长音频时长的行为；<br>
            ⑪ 每条声音需做降噪、环境音等后期处理，加入合适的背景音乐及音效；<br>
            ⑫ 上传的声音格式必须为MP3，采样频率至少为44100Hz，码率至少192Kbps，双声道，音量不低于50%，音质清晰，无噪；

        </p>
        <p class="title">3. 录制中间，能请假吗？</p>
        <p class="content">可以。不过请假次数有限，请在允许次数内请假喔。</p>
        <p class="title">4. 录制中断或延期怎么办？</p>
        <p class="content">录制中断或延期会影响您的信用，不利于您参与之后的海选任务。若因故需延迟录制内容，您可以在主播工作台内发起请假。在这里提醒一下，请假次数也是有限的，请谨慎使用哦。</p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {

    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// RecordDemand.vue?403684b4